export default function Deferred() {
  let resolve, reject;
  const promise = new Promise(function (_resolve, _reject) {
    reject = _reject;
    resolve = _resolve;
  });

  promise._reject = reject;
  promise._resolve = resolve;

  return promise;
}



// WEBPACK FOOTER //
// ./src/helpers/Deferred.js